<script setup lang="ts">
  import { SidebarTrigger, useSidebar } from '@gat-ship/vue-components'

  const { isMobile } = useSidebar()
</script>

<template>
  <!-- z-40 keeps it above page content but below reka overlays (z-50).
  Bottom-right: thumb-reachable, and clear of the top support-session
  status bar. -->
  <SidebarTrigger
    v-if="isMobile"
    class="bg-background/80 border-border fixed bottom-3 right-3 z-40 size-10 rounded-full border shadow-sm backdrop-blur md:hidden"
  />
</template>
